<template>
    <v-slide-group multiple show-arrows class="my-3">
        <v-slide-item
                v-for="item in itemsList"
                :key="item.id"
                v-slot:default="{ active, toggle }"
        >
            <v-btn
                    rounded
                    dark
                    small
                    depressed
                    class="main--yellow mr-2 px-2"
                    append-icon="highlight_off"
            >
                <span class="mr-2 text-truncate" style="max-width: 100px;" v-if="!item.link">{{ item.name }}</span>
                <router-link
                        :to="item.link"
                        class="mr-2 text-truncate white--text"
                        style="max-width: 100px;"
                        v-if="item.link"
                >
                    {{ item.name }}
                </router-link>
                <v-icon size="18" @click="deleteChip(item)">highlight_off</v-icon>
            </v-btn>
        </v-slide-item>
    </v-slide-group>
</template>

<script>
    import UrlGenerator from '../../../../general/mixins/UrlGenerator';

    export default {
        name: "ProductListChips",
        props:['chipsKey'],
        mixins: [UrlGenerator],
        data() {
            return {
                selectedItem: [],
                exceptedChips:['category']
            }
        },
        computed: {
            chipsData() {
                return this.$store.state.chips.category;
            },
            items() {
                return this.$store.state.chips[this.chipsKey];
            },
            itemsList() {
                const itemsList = [];
                const items = Object.entries(this.items);

                if(!items.length) return itemsList;

                for (let [key, item] of Object.entries(this.items)) {
                    if(Array.isArray(item)) {
                        item.forEach(chip => {
                            chip.filter = key;
                            chip.link = this.getChipLink(key, chip);
                            itemsList.push(chip)
                        });
                    } else {
                        item.filter = key;
                        item.link = this.getChipLink(key, item);
                        itemsList.push(item);
                    }
                }

                return itemsList;
            }
        },
        methods: {
            addFiltersToUrl(filters) {
                let [queryString, queryStringPrefix] = ['', '?'];
                for(let [key, value] of Object.entries(filters)) {
                    if(!value) continue;

                    if(!Array.isArray(value)) {
                        queryString += `${key}=${value}&`;
                    } else {
                        value.forEach((item, idx) => {
                            queryString += `${key}[]=${item}&`;
                        });
                    }
                }

                if(queryString) {
                    queryString = queryStringPrefix + queryString;
                }

                window.history.pushState({title: 'Update filters url'}, '', queryString)
            },
            deleteChip(chip) {
                let storeFilter = this.$store.state.filters[this.chipsKey][chip.filter];

                if(!storeFilter && storeFilter !== null) {
                    return false;
                }

                if(!Array.isArray(storeFilter)) {
                    const data = {
                        key: this.chipsKey,
                        name: chip.filter
                    };

                    this.$store.commit('deleteFilter', data);
                } else {
                    storeFilter = storeFilter.filter(item => {
                        return item !== chip.id;
                    });

                    const data = {
                        key: this.chipsKey,
                        name: chip.filter,
                        value: storeFilter
                    };

                    this.$store.commit('setFilter', data);
                    this.setStoreFiltersToUrl();
                    this.$emit('update-list');
                }
            },
            getChipLink(key, chip) {
                if(key === this.$store.state.filters.general.region.systemName) {
                    return this.urlRegionProducts(chip.system_name)
                } else {
                    return this.urlAttributeProducts(chip.attributeName, chip.system_name);
                }
            },
            setStoreFiltersToUrl() {
                if(this.chipsKey) {
                    this.addFiltersToUrl(this.$store.state.filters[this.chipsKey])
                }
            },
        }
    }
</script>
